import { createSlice } from '@reduxjs/toolkit';
import { UserService } from "../services/UserService";
import { presaVisioneActions } from './PresaVisione';

const userService = new UserService();

const initialState = { authorities: null, operatori: null, referenze: null, selected: sessionStorage.getItem('role_selected'), enteSelected: sessionStorage.getItem('ente_selected') };
const roleSlice = createSlice({
  name: 'role',
  initialState: initialState,
  reducers: {
    setRoles(state, action) {
      state.authorities = action.payload ? action.payload.authorities : null;
      state.operatori = action.payload ? action.payload.operatori : null;
      state.referenze = action.payload ? action.payload.referenze : null;
      state.selected = state.authorities && state.authorities.length === 1 ? state.authorities[0] : state.selected;
      state.enteSelected = state.operatori && state.operatori.length === 1 ? state.operatori[0] : state.enteSelected;
      if (state.selected) {
        sessionStorage.setItem('role_selected', state.selected);
      } else {
        sessionStorage.removeItem('role_selected');
      }
      if (state.enteSelected) {
        sessionStorage.setItem('ente_selected', state.enteSelected.id ?? state.enteSelected);
      } else {
        sessionStorage.removeItem('ente_selected');
      }
    },
    setRoleSelected(state, action) {
      state.selected = action.payload;
      if (action.payload) {
        sessionStorage.setItem('role_selected', action.payload);
      } else {
        state.enteSelected = null;
        sessionStorage.removeItem('role_selected');
        sessionStorage.removeItem('ente_selected');
      }
    },
    setEnteSelected(state, action) {
      state.enteSelected = action.payload?.toString();
      if (action.payload) {
        sessionStorage.setItem('ente_selected', state.enteSelected);
      } else {
        sessionStorage.removeItem('ente_selected');
      }
    },
    setRolesInError(state, action) {
      state.authorities = undefined;
    }
  }
});

export const fetchData = () => {
  return async (dispatch) => {
    const token = sessionStorage.getItem('access_token');
    const userInfo = sessionStorage.getItem('user_info');
    try {
      const data = token ? await userService.getUserRoles(userInfo) : null;
      dispatch(roleActions.setRoles(data));
      dispatch(presaVisioneActions.setData(data));
      checkRoleSelectedChangeInterval(data, dispatch);
    } catch (error) {
      dispatch(roleActions.setRolesInError(null));
    }
  };
};

const intervalTime = 1000;
const checkRoleSelectedChangeInterval = async (data, dispatch) => {
  setInterval(() => {
    if (data && data.authorities.length > 1) {
      const selected = sessionStorage.getItem('role_selected');
      if (selected !== null && selected !== undefined && data.selected !== null && data.selected !== undefined && selected !== data.selected) {
        dispatch(roleActions.setRoleSelected(selected));
      }
    }
  }, intervalTime);
}

export const roleActions = roleSlice.actions;
export default roleSlice.reducer;
